"use client";
/**
 * This code was generated by v0 by Vercel.
 * @see https://v0.dev/t/WCTh2OV7Pv9
 */
import { CardContent } from "@whiskey/web-ui/components/ui/card";
import Image from "next/image";
import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";

export type PlayerProps = {
  mix: {
    id: number;
    title: string;
    description: string;
    audioUrl: string;
    publishDate: string;
  };
};

export function Player(props: PlayerProps) {
  return (
    <CardContent className="flex flex-col items-center gap-4 p-6">
      <Image
        alt="Album cover"
        className="rounded-lg object-cover"
        height={250}
        src="https://assets.mattwyskiel.com/a-list/podcast-image.jpeg"
        width={250}
      />
      <div className="grid gap-2 text-center w-full">
        <p className="font-semibold">Playing now</p>
        <h3 className="font-bold text-xl">{props.mix.title}</h3>
        <p className="text-sm text-gray-500 dark:text-gray-400">
          {new Date(props.mix.publishDate).toDateString()}
        </p>
      </div>
      <AudioPlayer
        autoPlay
        src={props.mix.audioUrl}
        style={{
          backgroundColor: "transparent",
          color: "rgb(var(--foreground-rgb))",
        }}
        customAdditionalControls={[]}
        customVolumeControls={[]}
        // other props here
      />
      <div>
        <p className="text-med font-bold text-gray-500 dark:text-gray-400">
          Description
        </p>
        <p className="text-sm text-gray-500 dark:text-gray-400">
          {props.mix.description}
        </p>
      </div>
    </CardContent>
  );
}

// function ChevronRightIcon(props: any) {
//   return (
//     <svg
//       {...props}
//       xmlns="http://www.w3.org/2000/svg"
//       width="24"
//       height="24"
//       viewBox="0 24"
//       fill="none"
//       stroke="currentColor"
//       strokeWidth="2"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     >
//       <path d="m9 18 6-6-6-6" />
//     </svg>
//   );
// }
